export default __webpack_public_path__ + "static/media/coin2.b168da55.svg";